import {editable_user} from './user_file';

export const Legalex_API_Key = 'a4975c56-6822-4742-8a61-4bb0319cfd99'
export const app_user = editable_user;
export const theme_color = app_user == "nh" ? "#213675" : "#2196f3"
export const iconColor = theme_color;
export const ServerPath = app_user == "nh" ? "https://nh-services.com" : "https://legalex-services.com";
